export default __webpack_public_path__ + "static/media/11AW3NOV65.a0a8b81b.jpg";